export const env = {
  PM_GRAPH: process.env.PM_GRAPH,
  ADMIN_GRAPH: process.env.ADMIN_GRAPH,
  BASE_URL: process.env.BASE_URL,
  RT_CLUSTER_GRAPH: process.env.RT_CLUSTER_GRAPH,
  BRAND_ID: process.env.BRAND_ID || ``
  /*OAUTH: process.env.OAUTH,
  OAUTH_USER: process.env.OAUTH_USER,
  OAUTH_SECRET: process.env.OAUTH_SECRET,
  OAUTH_SCOPES: process.env.OAUTH_SCOPES,*/
};
